export default __webpack_public_path__ + "static/blog-post-1-f3359c18425b49f542e0630b777cbc32.png";